import { Component, OnInit } from '@angular/core';
import { CommonConstants } from '../../constant';

@Component({
  selector: 'ic-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  public footerText = CommonConstants.FooterText;

  constructor() {}

  ngOnInit(): void {}
}
